import type { GridSortModel } from '@mui/x-data-grid';
import type { SortingItem } from '@vy/types';
import { vySerialize } from '@vy/utils';
import { first } from 'lodash';
import { useStateParams } from './use-state-params';

export function useTableSorting<SortingItemType extends SortingItem | undefined>(
  defaultValue?: SortingItemType,
) {
  const [currentSortModel, setCurrentSortModel] = useStateParams<SortingItemType | undefined>(
    defaultValue,
    'sort',
    vySerialize,
    JSON.parse,
  );

  const handleSortModelChange = (sortModel: GridSortModel) => {
    setCurrentSortModel(first(sortModel) as SortingItemType);
  };

  return {
    currentSortModel,
    handleSortModelChange,
  };
}
